var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-dialog',{ref:"map-dialog",staticClass:"map-dialog",attrs:{"type":"confirm","title":"选择店铺地图定位"},on:{"ok":_vm.onOk,"cancel":_vm.onCancel}},[_c('iframe',{staticClass:"map-tencent",attrs:{"frameborder":"0","src":_vm.getMapUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }